import { VideoSource } from '~core/plugins/helpers/videoHelper'
import type { Event } from './events'
import type { Media } from './media'

export interface VideoSpeaker {
  company: string | null
  first_name: string
  id: number
  job: string
  last_name: string
  media: Media[]
  timezone: string
  is_subscription_active?: boolean
}

export interface VideoTag {
  id: number
  name: string
}

export interface Video {
  id: number
  title: string
  categories: number[]
  date: string
  description: string
  duration: number
  speakers: VideoSpeaker[]
  tags: VideoTag[]
  video_id: string
  video_url: string
  video_source: VideoSource
  temp_video_url?: string
  language: string | null
  meta_description: string | null
  meta_keywords: string | null
  meta_title: string | null
  popular: boolean | null
  preview: Media | null
  visibility_status: number
  event: Event
}

export const VideoEndpointMap = {
  Base: '/lecture-archive',
  Auth: '/lecture-archive/me',
} as const

export type VideoEndpoint =
  (typeof VideoEndpointMap)[keyof typeof VideoEndpointMap]
